export default __webpack_public_path__ + "static/media/dutgo-screenshot-04.54a1f997.png";